import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { nomService } from "../../services/api/nom.service";
import { alertService } from "../../services/helpers/alert.service";

export const PatientMMTemporaryAlocation = ({ cnp, activeComponent, pacient, searchCode }) => {
    const [searchValue, setSearchValue] = useState("");
    const [searchClicked, setSearchClicked] = useState(false);
    const [firme, setFirme] = useState([]);
    const navigate = useNavigate();
    const partener = sessionStorage.getItem('idPartener');

    const fetchData = () => {
        nomService.getTemporaryAlocation({ name:searchValue })
            .then(response => {
                if (response) {
                    setFirme(response);
                } else {
                    setFirme([]);
                }
            });
    };

    const handleSearch = () => {
        if (searchValue.length >= 3) {
            setSearchClicked(true);
            fetchData();
        }
    };

    const handleView = (page, param, value) => {

        let partener = sessionStorage.getItem('idPartener');
        if (partener == 0) {
            alertService.error("Selectati un partener");
            return;
        }

        if (!pacient) {
            alertService.error("Selectati un pacient");
            return;
        }   

        let queryString = '';

        // daca tipul lui param este obiect atunci il descompunem in cheie si valoare
        if (typeof param === 'object') {
            const keys = Object.keys(param);
            queryString = keys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(param[key])}`).join('&');
        }
        else {
            queryString = `${(param)}=${(value)}`;
        }
        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent,
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${queryString}`);
    }



    return (
        <>
            <table className="tbl" data-name="lista" width="100%">
                <thead>
                    <tr>
                        <th>Nr</th>
                        <th>Companie</th>
                        <th>Tip abonament</th>
                        <th width="75">Selecteaza</th>
                    </tr>
                    <tr>
                        <td colSpan="4">
                            <input
                                type="text"
                                data-name="filtru"
                                placeholder="Cauta"
                                className="filtru_cauta"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                            <button
                                data-name="btn-filtru"
                                name="btn-filtru"
                                className="btn"
                                onClick={handleSearch}
                            >
                                Cauta
                            </button>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {searchClicked &&
                        firme &&
                        firme.map((firma, index) => (
                            <tr key={index}>
                                <td data-name="nr_crt" className="center temptd">
                                    {index + 1}
                                </td>
                                <td data-name="firma" className="temptd">
                                    {firma.numeFirma}
                                </td>
                                <td data-name="nume_profil" className="temptd">
                                    {firma.numeProfil}
                                    {firma.firmaMaster && <span> (</span>}
                                    {firma.firmaMaster}
                                    {firma.firmaMaster && <span>)</span>}
                                </td>
                                <td className="center temptd">
                                    <a
                                        className="icon deschide center tmpicon"
                                        onClick={() => handleView("fisa-mm", { pacient: pacient, contract: firma.idContract })}
                                        title="Selecteaza"
                                        data-name="adauga"
                                    >
                                        Selecteaza
                                    </a>
                                    <br />
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
            
        </>
    );
};
